import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.scss';
import Main from './ts/Main';
import * as serviceWorker from './ts/code/serviceWorker';
import { Provider } from 'react-redux'
import configureStore from './ts/code/redux/store'

const store = configureStore

ReactDOM.render(
  <Provider store={store}>
    <Main />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
